export default __webpack_public_path__ + "static/media/sidebar-green@2x.4cc013d9.png";